import { Injectable } from '@angular/core';

export interface ParsedMedicineHint {
  raw: string;        // full raw token
  nameHint: string;   // thuja
  potencyHint: string; // 1m, 200c, q
  codeHint: string;   // t4, a63
}


export interface ParsedMedicineRow {
  tags: ParsedMedicineHint[];  // shorthand like ["nvm200", "lyc30"]
  dose: string;
  drams: string;
  ballers: string;
}

@Injectable({
  providedIn: 'root'
})

export class HomeopathyRowParserService {
  // parseRow(input: string): ParsedMedicineRow {
  //   const tokens = this.tokenize(input);

  //   const row: ParsedMedicineRow = {
  //     tags: [],
  //     dose: '',
  //     drams: '',
  //     ballers: ''
  //   };

  //   for (const token of tokens) {
  //     const med = this.parseMedicineToken(token);
  //     if (med) {
  //       row.tags.push(med);
  //       continue;
  //     }

  //     if (!row.dose && this.isDose(token)) {
  //       row.dose = token;
  //       continue;
  //     }

  //     if (!row.drams && this.isDrams(token)) {
  //       row.drams = token;
  //       continue;
  //     }

  //     if (!row.ballers && this.isBallers(token)) {
  //       row.ballers = token;
  //     }
  //   }

  //   return row;
  // }

  // parseRow(input: string): ParsedMedicineRow {
  //   const row: ParsedMedicineRow = {
  //     tags: [],
  //     dose: '',
  //     drams: '',
  //     ballers: ''
  //   };

  //   // 1️⃣ Split medicine part and dosing part
  //   // const [medicinePart, dosingPart] = input.split('-').map(s => s.trim());

  //   const dashIndex = input.indexOf('-');

  //   let medicinePart = input;
  //   let dosingPart = '';

  //   if (dashIndex !== -1) {
  //     medicinePart = input.slice(0, dashIndex).trim();
  //     dosingPart = input.slice(dashIndex + 1).trim();
  //   }

  //   // 2️⃣ Parse medicines (split by +)
  //   const medicineChunks = medicinePart.split('+').map(m => m.trim());

  //   for (const chunk of medicineChunks) {
  //     const hint = this.parseMedicineChunk(chunk);
  //     if (hint) {
  //       row.tags.push(hint);
  //     }
  //   }

  //   // 3️⃣ Parse dosing info
  //   if (dosingPart) {
  //     const tokens = dosingPart.toLowerCase().split(/\s+/);

  //     for (const token of tokens) {
  //       if (!row.dose && this.isDose(token)) row.dose = token;
  //       if (!row.drams && this.isDrams(token)) row.drams = token;
  //       if (!row.ballers && this.isBallers(token)) row.ballers = token;
  //     }
  //   }

  //   return row;
  // }

  // parseRow(input: string): ParsedMedicineRow {
  //   const row: ParsedMedicineRow = {
  //     tags: [],
  //     dose: '',
  //     drams: '',
  //     ballers: ''
  //   };

  //   // 🔥 SAFE split on FIRST '=' or '-' (whichever comes first)
  //   const match = input.match(/^(.*?)(?:\s*[=-]\s*)(.*)$/);

  //   let medicinePart = input.trim();
  //   let dosingPart = '';

  //   if (match) {
  //     medicinePart = match[1].trim();
  //     dosingPart = match[2].trim();
  //   }

  //   // 2️⃣ Parse medicines (split by +)
  //   const medicineChunks = medicinePart
  //     .split('+')
  //     .map(m => m.trim())
  //     .filter(Boolean);

  //   for (const chunk of medicineChunks) {
  //     const hint = this.parseMedicineChunk(chunk);
  //     if (hint) {
  //       row.tags.push(hint);
  //     }
  //   }

  //   // 3️⃣ Parse dosing info
  //   if (dosingPart) {
  //     const tokens = dosingPart
  //       .toLowerCase()
  //       .replace(/[.,]/g, '') // important
  //       .split(/\s+/);

  //     for (const token of tokens) {
  //       if (!row.dose && this.isDose(token)) row.dose = token;
  //       if (!row.drams && this.isDrams(token)) row.drams = token;
  //       if (!row.ballers && this.isBallers(token)) row.ballers = token;
  //     }
  //   }

  //   return row;
  // }

  parseRow(input: string): ParsedMedicineRow {
    const row: ParsedMedicineRow = {
      tags: [],
      dose: '',
      drams: '',
      ballers: ''
    };

    // 🔥 robust split
    const { medicinePart, dosingPart } =
      this.splitMedicineAndDosing(input);

    // 1️⃣ Medicines
    const medicineChunks = medicinePart
      .split('+')
      .map(m => m.trim())
      .filter(Boolean);

    for (const chunk of medicineChunks) {
      const hint = this.parseMedicineChunk(chunk);
      if (hint) row.tags.push(hint);
    }

    // 2️⃣ Dosing
    if (dosingPart) {
      this.parseDosing(dosingPart, row);
    }

    // if (dosingPart) {
    //   const tokens = dosingPart
    //     .toLowerCase()
    //     .replace(/[.,]/g, '')
    //     .split(/\s+/);

    //   for (const token of tokens) {
    //     if (!row.drams && this.isDrams(token)) row.drams = token;
    //     if (!row.ballers && this.isBallers(token)) row.ballers = token;
    //     if (!row.dose && this.isDose(token)) row.dose = token;
    //   }
    // }

    return row;
  }



  // ---------------- helpers ----------------

  // private parseMedicineChunk(chunk: string): ParsedMedicineHint | null {
  //   // Example: "Ars iod 10m(A102)"
  //   const match = chunk.match(
  //     /^(.+?)\s+(\d+(c|x|m)|q)?\s*\(([^)]+)\)?$/i
  //   );

  //   if (!match) {
  //     return {
  //       raw: chunk,
  //       nameHint: chunk.trim(),
  //       potencyHint: '',
  //       codeHint: ''
  //     };
  //   }

  //   return {
  //     raw: chunk,
  //     nameHint: match[1].trim(),
  //     potencyHint: (match[2] || '').toUpperCase(),
  //     codeHint: (match[4] || '').toUpperCase()
  //   };
  // }

  private parseMedicineChunk(chunk: string): ParsedMedicineHint {
    // Normalize spacing
    const normalized = chunk.replace(/\s+/g, ' ').trim();

    // Match:
    // name + potency (with or without space) + optional (CODE)
    const match = normalized.match(
      /^(.+?)(\d+(c|x|m)|q)?\s*\(?([A-Za-z]+0*\d+)?\)?$/i
    );

    if (!match) {
      return {
        raw: chunk,
        nameHint: chunk.trim(),
        potencyHint: '',
        codeHint: ''
      };
    }

    return {
      raw: chunk,
      nameHint: match[1]?.trim() || '',
      potencyHint: (match[2] || '').toUpperCase(),
      codeHint: (match[4] || '').toUpperCase()
    };
  }

  private splitMedicineAndDosing(input: string): {
    medicinePart: string;
    dosingPart: string;
  } {
    // Match FIRST occurrence of =, -, --, - -, etc.
    const match = input.match(/^(.*?)(?:\s*[=|-]{1,}\s*)(.*)$/);

    if (!match) {
      return {
        medicinePart: input.trim(),
        dosingPart: ''
      };
    }

    return {
      medicinePart: match[1].trim(),
      dosingPart: match[2].trim()
    };
  }




  private tokenize(input: string): string[] {
    return input
      .toLowerCase()
      .replace(/[=,+]/g, ' ')
      .split(/\s+/)
      .filter(Boolean);
  }

  /**
   * Parses: thuja 1m(t4), bell 30(a12), ars iod 10m(a102)
   */
  private parseMedicineToken(token: string): ParsedMedicineHint | null {
    const match = token.match(
      /^([a-z\s]+)?\s?(\d+(c|x|m)|q)?\s?\(?([a-z]\d+)?\)?$/i
    );

    if (!match) return null;

    return {
      raw: token,
      nameHint: (match[1] || '').trim(),
      potencyHint: (match[2] || '').toUpperCase(),
      codeHint: (match[4] || '').toUpperCase()
    };
  }

  // private isDose(token: string): boolean {
  //   return /^\d+\s?(dose|pills?|drops?)$/.test(token);
  // }

  // private isDrams(token: string): boolean {
  //   return /^\d+\s?(ml|gram|grams|dram|drams)$/.test(token);
  // }

  // private isBallers(token: string): boolean {
  //   return (
  //     /^\d-\d-\d$/.test(token) ||
  //     ['od', 'bd', 'tds', 'weekly', 'sunday', 'wednesday'].includes(token)
  //   );
  // }

  private isDose(token: string): boolean {
    return /^\d+\s?(dose|doses?)$/.test(token);
  }

  private isDrams(token: string): boolean {
    return /^\d+\s?(ml|gram|grams|dram|drams)$/.test(token);
  }

  private isBallers(token: string): boolean {
    return (
      /^\d+-\d+-\d+$/.test(token) ||
      ['od', 'bd', 'tds', 'weekly', 'daily', 'monthly', 'sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'].includes(token)
    );
  }

  private parseDosing(dosingPart: string, row: ParsedMedicineRow) {
    const clean = dosingPart
      .toLowerCase()
      .replace(/[.,]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    // -----------------------------
    // EXPLICIT SPLIT USING |
    // -----------------------------
    if (clean.includes('|')) {
      const [left, right] = clean.split('|').map(s => s.trim());

      // LEFT → DRAMS
      const dramMatch = left.match(
        /(\d+\/\d+|\d+)\s*(ml|gram|grams|dram|drams)\b/
      );
      if (dramMatch) {
        row.drams = `${dramMatch[1]}${dramMatch[2]}`;
      }

      // RIGHT → BALLERS
      // const tripleMatch = right.match(/\b\d+-\d+-\d+\b/);
      // if (tripleMatch) {
      //   row.ballers = tripleMatch[0];
      //   return;
      // }

      // const timesMatch = right.match(/\b(\d+)\s*times\b/);
      // if (timesMatch) {
      //   row.ballers = `${timesMatch[1]} times`;
      //   return;
      // }

      if (right) {
        row.ballers = right;
        return;
      }
    }

    // -----------------------------
    // FALLBACK (NO | FOUND)
    // -----------------------------

    // DRAMS
    if (!row.drams) {
      const dramMatch = clean.match(
        /(\d+\/\d+|\d+)\s*(ml|gram|grams|dram|drams)\b/
      );
      if (dramMatch) {
        row.drams = `${dramMatch[1]}${dramMatch[2]}`;
      }
    }

    // BALLERS
    if (!row.ballers) {
      const tripleMatch = clean.match(/\b\d+-\d+-\d+\b/);
      if (tripleMatch) {
        row.ballers = tripleMatch[0];
      }
    }

    if (!row.ballers) {
      const timesMatch = clean.match(/\b(\d+)\s*times\b/);
      if (timesMatch) {
        row.ballers = `${timesMatch[1]} times`;
      }
    }

    // DOSE (optional)
    if (!row.dose) {
      const doseMatch = clean.match(
        /\b(\d+)\s*(dose|doses|drop|drops|tab|tabs)\b/
      );
      if (doseMatch) {
        row.dose = `${doseMatch[1]} ${doseMatch[2]}`;
      }
    }
  }


}
